import type { ComponentProps } from 'react';
import { CardMedium } from './cards/card-medium';

type Props = {
  label: string;
  cards: Array<ComponentProps<typeof CardMedium>>;
};

export function MoreArticlesSection(props: Props) {
  const { label, cards } = props;

  const labelParts = label.split(' ');

  return cards.length === 0 ? null : (
    <section className='flex flex-col gap-14 overflow-hidden pb-18'>
      <h2 className='text-center font-["Poppins"] text-[40px] leading-10 font-semibold'>
        <span className='text-azure-595'>{labelParts[0]}</span>
        <span className='text-black'> {labelParts.slice(1).join(' ')}</span>
      </h2>
      <div className='mx-auto flex max-h-[500px] w-full max-w-[1296px] gap-4 px-4 pb-4 xl:gap-6'>
        {cards.map((card) => (
          <CardMedium key={card.title} {...card} />
        ))}
      </div>
    </section>
  );
}
